import micromark from 'micromark'

interface MarkdownProps extends React.HTMLAttributes<HTMLDivElement> {
  markdown: string
}

const Markdown = (props: MarkdownProps): JSX.Element => {
  return (
    <div
      className={'prose max-w-none ' + props.className ?? ''}
      dangerouslySetInnerHTML={{
        __html: micromark(props.markdown.replace(/\n+/g, '\n\n')),
      }}
    />
  )
}

export default Markdown
